import { render, staticRenderFns } from "./add-advertising-position.vue?vue&type=template&id=5b6a9e90&scoped=true"
import script from "./add-advertising-position.vue?vue&type=script&lang=ts"
export * from "./add-advertising-position.vue?vue&type=script&lang=ts"
import style0 from "./add-advertising-position.vue?vue&type=style&index=0&id=5b6a9e90&prod&lang=stylus&module=true"
import style1 from "./add-advertising-position.vue?vue&type=style&index=1&id=5b6a9e90&prod&lang=stylus&scoped=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "5b6a9e90",
  null
  
)

export default component.exports